import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { DaTableCell, DaTableRow } from '@paygreen/paygreen-ui';
import { IsBigDesktop } from '../../utils/tools';
import { HideAndCopy } from '../../components';
import ActionsCell from './ActionsCell';

const MemoizedRow = memo(
    ({ t, data, row, setModalData, isActive, className }) => {
        // needed to guarantee vertical alignment on tablet for last cell in table
        const actionCellboxProps = {
            style: {
                display: IsBigDesktop() ? null : 'flex',
                justifyContent: IsBigDesktop() ? null : 'flex-end',
                overflow: 'visible',
            },
        };

        const { id, categoryName } = row.values;
        const selectedCategory = data.filter((elem) => elem.id === id)[0];
        return (
            <DaTableRow
                {...row.getRowProps()}
                key={row.id}
                isActive={isActive}
                className={className}
            >
                <DaTableCell
                    isMain={false}
                    label={t('categories.table.id')}
                    title={id}
                >
                    {id}
                </DaTableCell>

                <DaTableCell
                    label={t('categories.table.name')}
                    title={categoryName}
                >
                    <HideAndCopy
                        text={categoryName}
                        startLength={50}
                        endLength={null}
                        hasCopyButton={true}
                    />
                </DaTableCell>
                <DaTableCell label="Actions" {...actionCellboxProps}>
                    <ActionsCell
                        selectedCategory={selectedCategory}
                        setModalData={setModalData}
                    />
                </DaTableCell>
            </DaTableRow>
        );
    },
);

MemoizedRow.propTypes = {
    data: PropTypes.array.isRequired,
    setModalData: PropTypes.func,
    isActive: PropTypes.bool,
    className: PropTypes.string,
    row: PropTypes.object,
};

MemoizedRow.defaultProps = {
    isLoading: false,
};

export default withTranslation('common')(MemoizedRow);
